/**
 * Registrerer den minimale service worker (public/sw.js) kun i produktions-builds.
 * Workeren cacher kun app-shell/offline-side og uforanderlige /assets/*; aldrig API, auth eller kortdata.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Offline-fallback er en bonus; appen virker uden.
    });
  });
}
